import React from "react"

import classes from "./ContentTabs.module.scss"

const ContentTabs: React.FC = ({ children }) => {
  return <div className={classes.ContentTabs}>{children}</div>
}

export default ContentTabs
